module.exports = {"VUE_APP_TITLE":"PG POH","VUE_APP_LABEL":"POH Admin","VUE_APP_VERSION":"1.9.72","VUE_APP_DOTNET_API_EXCHANGE_BASE_PATH":"exchange/redir/"}


//////////////////
// WEBPACK FOOTER
// ./static/data/common.appconfig.json
// module id = 8Hhh
// module chunks = 1